<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g class="fill-current">
      <path
        d="M29.132 3.636h-22.953c-1.463 0-2.649 1.186-2.649 2.649v0 0.883h-0.881c-1.462 0-2.648 1.185-2.649 2.647v15.891c0 1.463 1.186 2.649 2.649 2.649v0h22.951c1.463 0 2.649-1.186 2.649-2.649v0-0.883h0.883c1.463 0 2.649-1.186 2.649-2.649v0-15.889c0-1.463-1.186-2.649-2.649-2.649v0zM26.483 25.706c-0.001 0.487-0.396 0.882-0.883 0.883h-22.951c-0.487-0.001-0.882-0.396-0.883-0.883v-15.891c0.001-0.487 0.396-0.882 0.883-0.883h0.883v13.236c0 1.463 1.186 2.649 2.649 2.649v0h20.303zM30.015 22.175c-0.001 0.487-0.396 0.882-0.883 0.883h-22.953c-0.487-0.001-0.882-0.396-0.883-0.883v-15.89c0.001-0.487 0.396-0.882 0.883-0.883h22.953c0.487 0.001 0.882 0.396 0.883 0.883v0zM9.711 12.906c1.706 0 3.089-1.383 3.089-3.089s-1.383-3.089-3.089-3.089c-1.706 0-3.089 1.383-3.089 3.089v0c0 1.706 1.383 3.089 3.089 3.089v0zM9.711 8.492c0.731 0 1.324 0.593 1.324 1.324s-0.593 1.324-1.324 1.324c-0.731 0-1.324-0.593-1.324-1.324v0c0.001-0.731 0.593-1.323 1.324-1.324h0zM23.007 9.763c-0.24-0.24-0.57-0.388-0.936-0.388s-0.696 0.148-0.936 0.388l-5.236 5.236-1.721-1.706c-0.24-0.24-0.57-0.388-0.936-0.388s-0.696 0.148-0.936 0.388l-4.855 4.855c-0.24 0.24-0.388 0.571-0.388 0.937 0 0 0 0 0 0v0 1.545c0 0.366 0.296 0.662 0.662 0.662v0h19.863c0.366 0 0.662-0.296 0.662-0.662v0-5.076c-0-0.366-0.149-0.697-0.388-0.937v0zM26.484 19.527h-17.657v-0.259l4.409-4.415 2.649 2.649 6.179-6.179 4.415 4.415z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
